import { render } from "./Opportunity.vue?vue&type=template&id=0fd26fe8&scoped=true"
import script from "./Opportunity.vue?vue&type=script&lang=js"
export * from "./Opportunity.vue?vue&type=script&lang=js"

import "./Opportunity.vue?vue&type=style&index=0&id=0fd26fe8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd26fe8"]])

export default __exports__